import React, { useEffect, useRef, useState } from "react";
import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { mapStyles } from "../../../../../utils/map-styles.js";
import MapControls from "../../../../../components/map-report/map-buttons-control.jsx";
import { GoogleMapsOverlay } from "@deck.gl/google-maps";
import { HeatmapLayer } from "@deck.gl/aggregation-layers";

const MapContent = ({ coordinates = [] }) => {
    const map = useMap();
    const mapsLib = useMapsLibrary("maps");

    const heatmapRef = useRef(null);
    const [mapState, setMapState] = useState({
        neighborhoodStreets: false,
        pointsOfInterest: false
    });

    useEffect(() => {
        if (!map) return;

        map.setOptions({
            styles: mapStyles({
                neighborhoodStreets: mapState.neighborhoodStreets,
                pointsOfInterest: mapState.pointsOfInterest
            })
        });
    }, [mapState, map]);

    const buildData = () => {
        const heatmap = [];

        for (let i = 0; i < coordinates.length; i += 2) {
            const lat = parseFloat(coordinates[i]);
            const lng = parseFloat(coordinates[i + 1]);

            if (isNaN(lat) || isNaN(lng)) continue;

            const latLng = new google.maps.LatLng(lat, lng);
            heatmap.push(latLng);
        }

        return { heatmap };
    };

    useEffect(() => {
        if (!map) return;

        if (!heatmapRef.current) {
            heatmapRef.current = new GoogleMapsOverlay({});
            heatmapRef.current.setMap(map);
        }
    }, [map]);

    useEffect(() => {
        if (!map || !mapsLib) return;

        const { heatmap } = buildData();

        const bounds = new google.maps.LatLngBounds();

        heatmap.forEach(latLng => {
            bounds.extend(latLng);
        });

        const applyBounds = () => {
            if (!bounds.isEmpty()) map.fitBounds(bounds);
        };

        if (heatmapRef.current) {
            heatmapRef.current.setProps({ layers: [] });
        }

        const heatmapData = heatmap.map(latLng => ({position: [latLng.lng(), latLng.lat()], weight: 1}));
        heatmapRef.current.setProps({
            layers: [
                new HeatmapLayer({
                    id: "heatmap",
                    data: heatmapData,

                    getPosition: data => data.position,
                    getWeight: data => data.weight,

                    radiusPixels: 40,
                    intensity: 1,
                    threshold: 0.05
                })
            ]
        });

        heatmapRef.current.setMap(map);
        applyBounds();

    }, [coordinates, map, mapsLib]);

    return (
        <MapControls
            mapState={mapState}
            onTogglePOI={() => setMapState(p => ({ ...p, pointsOfInterest: !p.pointsOfInterest }))}
            onToggleNeighborhood={() => setMapState(p => ({ ...p, neighborhoodStreets: !p.neighborhoodStreets }))}
        />
    );
};

export default MapContent;